export type LoadPreviewImageOptions = {
  crossOrigin?: string
}

export function loadPreviewImage(src: string, options?: LoadPreviewImageOptions): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    if (options?.crossOrigin) {
      img.crossOrigin = options.crossOrigin
    }
    const cleanup = () => {
      img.onload = null
      img.onerror = null
    }
    img.onload = () => {
      cleanup()
      resolve(img)
    }
    img.onerror = (event) => {
      cleanup()
      reject(event)
    }
    img.src = src
    if (img.complete && img.naturalWidth > 0) {
      cleanup()
      resolve(img)
    }
  })
}
